export default { sha: '254ad9fb801129d55106d528c022c0ca5fcdf487', buildNumber: 'undefined' }
